import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  headersBase,
  headersType,
} from "../../../utils/constants/headersForApi";

export const chatbotApi = createApi({
  reducerPath: "chatbot-ia",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["bot", "bots", "chat", "file"],
  endpoints: (builder) => ({
    createChatbot: builder.mutation({
      query: (body) => ({
        url: `admin/chatbot/chatbot`,
        method: "POST",
        headers: headersType(),
        body: body,
      }),
      invalidatesTags: ["chat"],
    }),

    getAllBot: builder.query({
      query: ({ withDocuments, withPrompt } = {}) => {
        // Costruisce i parametri query solo se i valori sono definiti
        const params = new URLSearchParams();

        if (withDocuments !== undefined) {
          params.append("withDocuments", withDocuments);
        }

        if (withPrompt !== undefined) {
          params.append("withPrompt", withPrompt);
        }

        // Costruisce l'URL con i parametri se presenti
        const queryString = params.toString();
        const url = `admin/chatbot/agents${queryString ? `?${queryString}` : ""
          }`;

        return {
          url,
          method: "GET",
          headers: headersBase(),
        };
      },
      providesTags: ["bots"],
    }),
    getBotId: builder.query({
      query: (id) => ({
        url: `admin/Chatbot/agents/${id}`,
        method: "GET",
        headers: headersBase(),
      }),
      providesTags: ["bot"]
    }),
    createBot: builder.mutation({
      query: (newBot) => ({
        url: "admin/Chatbot/agents",
        method: "POST",
        headers: headersType(),
        body: newBot,
      }),
      invalidatesTags: ["bot", "bots"],
    }),
    editBot: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `admin/Chatbot/agents/${id}`,
        method: "PUT",
        headers: headersType(),
        body: body,
      }),
      invalidatesTags: ["bot", "bots"],
    }),
    deleteBot: builder.mutation({
      query: (id) => ({
        url: `admin/Chatbot/agents/${id}`,
        method: "DELETE",
        headers: headersBase(),
      }),
      invalidatesTags: ["bot", "bots"],
    }),
    getArchivedConversations: builder.query({
      query: () => ({
        url: "admin/Chatbot/conversations",
        method: "GET",
        headers: headersBase(),
      }),
      providesTags: ["chat"],
    }),

    deleteArchivedConversation: builder.mutation({
      query: (conversationId) => ({
        url: `admin/Chatbot/conversations/${conversationId}`,
        method: "DELETE",
        headers: headersBase(),
      }),
      invalidatesTags: ["chat"],
    }),

    getConversationById: builder.query({
      query: (conversationId) => ({
        url: `admin/Chatbot/conversations/${conversationId}`,
        method: "GET",
        headers: headersBase(),
      }),
      providesTags: ["chat"],
    }),
    uploadDocuments: builder.mutation({
      query: ({ agentId, files }) => ({
        url: "admin/Chatbot/upload-documents",
        method: "POST",
        headers: headersType(),
        body: { agentId, files },
      }),
      invalidatesTags: ["file", "bots"],
    }),
    deleteDocument: builder.mutation({
      query: (documentId) => ({
        url: `admin/Chatbot/delete-document/${documentId}`,
        method: "DELETE",
        headers: headersBase(),
      }),
      invalidatesTags: ["file", "bots"],
    }),
    getDocumentFile: builder.query({
      query: (documentId) => ({
        url: `admin/Chatbot/documents/${documentId}/download`,
        method: "GET",
        headers: headersBase(),
        responseHandler: (response) => response.blob(),
        parseEndpoint: false,
      }),
      providesTags: ["file"]
    }),
  }),
});

export const {
  useCreateChatbotMutation,
  useGetAllBotQuery,
  useGetBotIdQuery,
  useCreateBotMutation,
  useEditBotMutation,
  useDeleteBotMutation,
  useGetArchivedConversationsQuery,
  useDeleteArchivedConversationMutation,
  useGetConversationByIdQuery,
  useLazyGetConversationByIdQuery,
  useUploadDocumentsMutation,
  useDeleteDocumentMutation,
  useGetDocumentFileQuery,
  useLazyGetDocumentFileQuery,
} = chatbotApi;
